import React from 'react';
import SeoArticlePage from './SeoArticlePage';

export default function HowIplTradingWorksPage() {
  return (
    <SeoArticlePage
      title="How IPL Trading Works | IPL Player Trading Game India"
      description="Understand how IPL trading works in a fantasy stock format. Learn price movement, strategy and risk control in IPL player trading game India."
      canonicalPath="/how-ipl-trading-works"
      keywords="how ipl trading works, ipl player trading game india, ipl player trading, fantasy cricket prediction"
      heading="How IPL Trading Works"
      intro="IPLTrade lets you trade virtual player stocks. Prices move with performance and market demand, creating a strategy-first fantasy experience."
      sections={[
        {
          title: 'Core Mechanics',
          body: 'You buy virtual units of players and portfolio value updates as player prices change through the season.',
          bullets: ['No real money deposits', 'Price reacts to match performance', 'Trade count limits enforce discipline'],
        },
        {
          title: 'Decision Framework',
          body: 'Use pre-match intel, live role context and post-match review to improve decision quality each round.',
        },
        {
          title: 'Common Mistakes',
          body: 'Late entries after hype and panic exits after one bad game are the two biggest portfolio killers.',
        },
      ]}
    />
  );
}
